import {getDrugItemFormDefaultValues} from '@/modules/drug-catalog/functions'
import {SolutionFormSchema} from '@/modules/drug-catalog/solutions/schemas'
import {elementToArray} from '@cypro/ui/utils'
import {DrugCatalogItem} from '@cypro/engine/schema'

export function getSolutionFormDefaultValues(solution: DrugCatalogItem | undefined): SolutionFormSchema {
  return {
    ...getDrugItemFormDefaultValues(solution),
    concentrationUnitId: elementToArray(solution?.solutionDetails?.concentrationUnitId),
    concentrationValue: solution?.solutionDetails?.concentrationValue || 0,
    types: solution?.solutionDetails?.types?.map(item => item.solutionTypeId) || [],
    machineId: '',
    carrierType: '0',
  }
}

export function isSolutionDeletable(_solution: DrugCatalogItem) {
  return true
}
